import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './public/login/login.component';
import { MainComponent } from './private/layout/main/main.component';
import { HomeComponent } from './private/modules/home/home.component';
import { ForgetComponent } from './public/forget/forget.component';
import { ResetComponent } from './public/reset/reset.component';
import { LeadComponent } from './private/modules/lead/lead.component';
import { PatientsComponent } from './private/modules/patients/patients.component';
import { UsersComponent } from './private/modules/configuration/users/users.component';
import { AuthGuard } from './utils/auth.guard';
import { ScheduleComponent } from './private/modules/configuration/schedule/schedule.component';
import { PriceSettingsComponent } from './private/modules/configuration/price-settings/price-settings.component';
import { CouponSettingsComponent } from './private/modules/configuration/coupon-settings/coupon-settings.component';
import { EmailSettingsComponent } from './private/modules/configuration/email-settings/email-settings.component';
import { ReportsComponent } from './private/modules/reports/reports.component';
import { ProcedurePackageComponent } from './private/modules/configuration/procedure-package/procedure-package.component';
import { FeedbackComponent } from './private/modules/feedback/feedback.component';
import { DrugInventoryComponent } from './private/modules/configuration/drug-inventory/drug-inventory.component';
import { SupplyInventoryComponent } from './private/modules/configuration/supply-inventory/supply-inventory.component';
import { EquipmentInventoryComponent } from './private/modules/configuration/equipment-inventory/equipment-inventory.component';
import { PricingDashboardComponent } from './private/modules/configuration/pricing-dashboard/pricing-dashboard.component';
import { PharmacyComponent } from './private/modules/pharmacy/pharmacy.component';
import { OpticalsComponent } from './private/modules/opticals/opticals.component';
import { BillingStatementTableComponent } from './private/modules/components/billing-statement-table/billing-statement-table.component';
import { IpdReportComponent } from './private/modules/components/ipd-report/ipd-report.component';
import { ManagementReportsComponent } from 'src/app/private/modules/components/management-reports/management-reports.component';
import { ContactGroupsComponent } from './private/modules/configuration/contact-groups/contact-groups.component';
import { WhatsappTemplateComponent } from './private/modules/configuration/whatsapp-template/whatsapp-template.component';
import { EmailTemplateComponent } from './private/modules/configuration/email-template/email-template.component';
import { SalesMailHubComponent } from './private/modules/configuration/sales-mail-hub/sales-mail-hub.component';
import { BroadcastCampaignComponent } from './private/modules/configuration/broadcast-campaign/broadcast-campaign.component';
import { ClientSettingComponent } from './private/modules/configuration/client-setting/client-setting.component';
import { DomainAuthenticationComponent } from './private/modules/configuration/domain-authentication/domain-authentication.component';
import { EmailCampaignAnalyticsComponent } from './private/modules/components/email-campaign-analytics/email-campaign-analytics.component';
import { WhatsappCampaignAnalyticsComponent } from './private/modules/components/whatsapp-campaign-analytics/whatsapp-campaign-analytics.component';
import { PipelineConfigurationComponent } from './private/modules/configuration/pipeline-configuration/pipeline-configuration.component';
import { AiScoringGuidelinesComponent } from './private/modules/configuration/ai-scoring-guidelines/ai-scoring-guidelines.component';
import { AnalyticsComponent } from './private/modules/analytics/analytics.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: "full",
    title: "TINA"
  },
  {
    path: 'login',
    component: LoginComponent,
    title: "TINA"
  },
  {
    path: 'forget-password',
    component: ForgetComponent,
    title: "Forget Password"
  },
  {
    path: 'reset-password/:type/:token',
    component: ResetComponent,
    title: "Reset Password"
  },
  {
    path: 'public/form/:token',
    loadComponent: () => import('./public/public-form/public-form.component').then(m => m.PublicFormComponent),
    title: "Form Submission"
  },
  {
    path: 'main',
    component: MainComponent,
    canActivate: [AuthGuard],
    children:[{
      path:"",
      data:{
        title:"Manage Leads"
      },
      component:LeadComponent,
      canActivate: [AuthGuard],
    },
    {
      path:"patients",
      data:{
        title:"Manage Patients"
      },
      component:PatientsComponent,
      canActivate: [AuthGuard],
    },
    {
      path: 'home',
      component: HomeComponent,
      title: "Home",
      data:{
        title:"Analytics Dashboard"
      },
      canActivate: [AuthGuard]
     },
     {
      path: 'analytics',
      redirectTo: 'home',
      pathMatch: 'full'
     },
     {
      path: 'leads',
      component: LeadComponent,
      canActivate: [AuthGuard],
      title: "Leads",
      data:{
        title:"Manage Leads"
      }
     },
     {
      path: 'leads-v2',
      canActivate: [AuthGuard],
      loadChildren: () => import('./private/modules/lead-v2/lead-v2.module').then(m => m.LeadV2Module),
      title: "Leads CRM",
      data:{
        title:"Manage Leads"
      }
     },{
      path: 'manage-campaign',
      loadChildren: () => import('./private/modules/campaign/campaign.module').then(m => m.CampaignModule),
      canActivate: [AuthGuard],
      title: "Campaign",
      data:{
        title:"Manage Campaign"
      }
      
      
     },
     {
      path: 'configuration-users',
      component: UsersComponent,
      title: "Users",
      canActivate: [AuthGuard],
      data:{
        title:"Manage Users"
      }
     },
     {
      path: 'configuration-email',
      component: EmailSettingsComponent,
      canActivate: [AuthGuard],
      title: "Email",
      data:{
        title:"Email Settings"
      }
     },
     {
      path: 'configuration-schedule',
      component: ScheduleComponent,
      canActivate: [AuthGuard],
      title: "Schedule",
      data:{
        title:"Schedule Settings"
      }
     },
     {
      path: 'opd-statement',
      component: BillingStatementTableComponent,
      canActivate: [AuthGuard],
      title: "Opd Statement",
      data:{
        title:"Opd Statement"
      }
     },
     {
      path: 'ipd-statement',
      component: IpdReportComponent,
      canActivate: [AuthGuard],
      title: "Ipd Statement",
      data:{
        title:"Ipd Statement"
      }
     },
     {
      path: 'procedure-packages',
      component: ProcedurePackageComponent,
      canActivate: [AuthGuard],
      title: "Procedure Packages",
      data:{
        title:"Procedure Packages"
      }
     },
     {
      path: 'price-settings',
      component: PriceSettingsComponent,
      canActivate: [AuthGuard],
      title: "Price",
      data:{
        title:"Price Settings"
      }
     },
     {
      path: 'coupon-settings',
      component: CouponSettingsComponent,
      canActivate: [AuthGuard],
      title: "Coupon",
      data:{
        title:"Coupon Settings"
      }
     },
     {
      path: 'drug-inventory',
      component: DrugInventoryComponent,
      canActivate: [AuthGuard],
      title: "Drug Inventory",
      data:{
        title:"Drug Inventory"
      }
     }
     ,
     {
      path: 'supply-inventory',
      component: SupplyInventoryComponent,
      canActivate: [AuthGuard],
      title: "Supply Inventory",
      data:{
        title:"Supply Inventory"
      }
     },
     {
      path: 'equipment-inventory',
      component: EquipmentInventoryComponent,
      canActivate: [AuthGuard],
      title: "Equipment Inventory",
      data:{
        title:"Equipment Inventory"
      }
     },
     {
      path: 'account-packages',
      component: PricingDashboardComponent,
      // canActivate: [AuthGuard],
      title: "Account Packages",
      data:{
        title:"Account Packages"
      }
     }
     , {
      path: 'appointments',
      loadChildren: () => import('./private/modules/appointment/appointment.module').then(m => m.AppointmentModule),
      canActivate: [AuthGuard],
      title: "Appointments",
      data:{
        title:"Manage Appointments"
      }
     },
     {
      path: 'out-patient',
      canActivate: [AuthGuard],
      loadChildren: () => import('./private/modules/opd/opd.module').then(m => m.OpdModule),
      title: "OPD",
      data:{
        title:"Manage Out Patient"
      }
     },
     {
      path: 'in-patient',
      canActivate: [AuthGuard],
      loadChildren: () => import('./private/modules/ipd/ipd.module').then(m => m.IpdModule),
      title: "IPD",
      data:{
        title:"Manage In Patient"
      }
     },
     {
      path: 'pharmacy',
      canActivate: [AuthGuard],
      component: PharmacyComponent,
      title: "Pharmacy",
      data:{
        title:"Pharmacy"
      }
     },
     {
      path: 'optical',
      canActivate: [AuthGuard],
      component: OpticalsComponent,
      title: "Optical",
      data:{
        title:"Optical"
      }
     },
     {
      path: 'reports',
      canActivate: [AuthGuard],
      component: ReportsComponent,
      title: "Reports",
      data:{
        title:"Manage Reports"
      }
     },
     {
      path: 'management-reports/:slug',
      canActivate: [AuthGuard],
       component: ManagementReportsComponent,
      title: "Management Reports",
      data:{
        title:"Manage Reports"
      }
     },
     {
      path: 'manage-tickets',
      canActivate: [AuthGuard],
      loadChildren: () => import('./private/modules/manage-tickets/manage-tickets.module').then(m => m.ManageTicketsModule),
      title: "Manage Tickets",
      data:{
        title:"Manage Tickets"
      }
     },
     {
      path: 'manage-feedbacks',
      canActivate: [AuthGuard],
      component:FeedbackComponent,
      title: "Manage Feedbacks",
      data:{
        title:"Manage Feedbacks"
      }
     },
     {
      path: 'contact-groups',
      component: ContactGroupsComponent,
      canActivate: [AuthGuard],
      title: "Contact Groups",
      data:{
        title:"Contact Groups",
        module: 'setting',
        feature: 'contact_group'
      }
     },
     {
      path: 'configuration-whatsapp-template',
      component: WhatsappTemplateComponent,
      canActivate: [AuthGuard],
      title: "WhatsApp Template",
      data:{
        title:"WhatsApp Template Settings",
        module: 'setting',
        feature: 'whatsapp_template'
      }
     },
     {
      path: 'configuration-email-template',
      component: EmailTemplateComponent,
      canActivate: [AuthGuard],
      title: "Email Template",
      data:{
        title:"Email Template Settings",
        module: 'setting',
        feature: 'email_template'
      }
     },
     {
      path: 'sales-mail-hub',
      component: SalesMailHubComponent,
      canActivate: [AuthGuard],
      title: "Sales Mail Hub",
      data:{
        title:"Sales Mail Hub"
      }
     },
     {
      path: 'broadcast-campaign',
      component: BroadcastCampaignComponent,
      canActivate: [AuthGuard],
      title: "Broadcast Campaign",
      data:{
        title:"Broadcast Campaign"
      }
     },
     {
      path: 'email-campaign-anlaytics/:id',
      component: EmailCampaignAnalyticsComponent,
      canActivate: [AuthGuard],
      title: "Email Campaign Analytics",
      data:{
        title:"Email Campaign Analytics"
      }
     },
     {
      path: 'whatsapp-campaign-analytics/:id',
      component: WhatsappCampaignAnalyticsComponent,
      canActivate: [AuthGuard],
      title: "WhatsApp Campaign Analytics",
      data:{
        title:"WhatsApp Campaign Analytics"
      }
     },
     {
      path: 'domain-authentication',
      component: DomainAuthenticationComponent,
      //   // canActivate: [AuthGuard],,
      title: "Domain Authentication",
      data:{
        title:"Domain Authentication"
      }
     },
     {
      path: 'client-settings/:tab',
      component: ClientSettingComponent,
      //   // canActivate: [AuthGuard],,
      title: "Client Settings",
      data:{
        title:"Client Settings",
        module: 'setting',
        feature: 'client_settings'
      }
     },
     {
      path: 'client-settings',
      component: ClientSettingComponent,
      //   // canActivate: [AuthGuard],,
      title: "Client Settings",
      data:{
        title:"Client Settings",
        module: 'setting',
        feature: 'client_settings'
      }
     },
     {
      path: 'configuration/pipeline-configuration',
      component: PipelineConfigurationComponent,
      canActivate: [AuthGuard],
      title: "Pipeline Configuration",
      data:{
        title:"Pipeline Configuration",
        module: 'setting',
        feature: 'pipeline_configuration'
      }
     },
     {
      path: 'configuration/ai-scoring-guidelines',
      component: AiScoringGuidelinesComponent,
      canActivate: [AuthGuard],
      title: "AI Scoring Guidelines",
      data:{
        title:"AI Scoring Guidelines",
        module: 'setting',
        feature: 'ai_scoring_guidelines'
      }
     },
     {
      path: 'ai-ocr',
      canActivate: [AuthGuard],
      loadChildren: () => import('./private/modules/ai-ocr/ai-ocr.module').then(m => m.AiOcrModule),
      title: "AI OCR",
      data:{
        title:"AI OCR & Document Intelligence"
      }
     },
     {
      path: 'settings/form-builder',
      loadComponent: () => import('./private/modules/configuration/form-builder/form-builder.component').then(m => m.FormBuilderComponent),
      title: "Dynamic Form Builder",
      data: {
        title: "Dynamic Form Builder"
      }
     }
  ]
    
  },
  { path: '**', 
  pathMatch: 'full', 
  component: LoginComponent 
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {

  
 }
